import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useDebounceCallback } from 'usehooks-ts';

export const documentsQueryKey = ['documents'] as const;
const INVALIDATION_WINDOW_MS = 2000;
const INVALIDATION_DEBOUNCE_OPTIONS = { leading: true, trailing: true } as const;

export const useInvalidateDocuments = (): (() => void) => {
    const queryClient = useQueryClient();
    const invalidateDocuments = useCallback(() => {
        void queryClient.invalidateQueries({ queryKey: documentsQueryKey });
    }, [queryClient]);

    return useDebounceCallback(invalidateDocuments, INVALIDATION_WINDOW_MS, INVALIDATION_DEBOUNCE_OPTIONS);
};
